import React from 'react';
import PropTypes from 'prop-types';
import * as Yup from 'yup';
import {Link} from 'gatsby';
import {InputText, InputCheckbox, InputLocation} from '@evag/ec-react';

import Button from 'src/components/Button';
import s from './Basic.module.scss';
import is from './inputs.module.scss';

const subscribeText = 'Quero receber novidades da Sâmia.';
const materiaisText = 'Quero receber materiais na minha casa.';
const materiaisUF = 'SP';

const Basic = ({
  title,
  values,
  onChange,
  onBlur,
  setFieldValue,
  showMateriais,
  showSubscribe,
  btnText,
}) => {
  const props = (name) => ({name, value: values[name], onChange, onBlur});
  return (
    <>
      <p>{title}</p>
      <InputText
        className={is.text}
        placeholder="Nome completo"
        {...props('name')}
      />
      <InputText
        className={is.text}
        placeholder="E-mail"
        type="email"
        {...props('email')}
      />
      <InputText
        className={is.text}
        cleave={{
          blocks: [0, 2, 9],
          delimiters: ['(', ') '],
          numericOnly: true,
        }}
        placeholder="WhatsApp"
        type="tel"
        {...props('phone')}
      />
      <InputLocation
        className={is.select}
        names={['uf', 'city']}
        firstUf="SP"
        {...{values, onChange, onBlur, setFieldValue}}
      />

      {showSubscribe ? (
        <InputCheckbox
          className={is.checkbox + ' ' + s.checkbox}
          label={subscribeText}
          {...props('subscribe')}
        />
      ) : (
        <input type="hidden" name="subscribe" value={values.subscribe} />
      )}

      {showMateriais && values.uf === materiaisUF && values.city ? (
        <InputCheckbox
          className={is.checkbox + ' ' + s.checkbox}
          label={materiaisText}
          {...props('material')}
        />
      ) : null}

      <input type="hidden" name="redirect" value={values.redirect} />
      <Button type="submit" fontSize="16px" width="100%">
        {btnText}
      </Button>
      <p className={s.privacy}>
        <Link to="/politica-de-privacidade">Política de privacidade</Link>
      </p>
    </>
  );
};

Basic.propTypes = {
  btnText: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  values: PropTypes.object.isRequired,
  onBlur: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  materiaisText: PropTypes.string,
  showSubscribe: PropTypes.bool,
  showMateriais: PropTypes.bool,
};

Basic.initialValues = {
  name: '',
  email: '',
  phone: '',
  uf: '',
  city: '',
  material: false,
  subscribe: false,
  redirect: 'https://samiabomfim.com.br/ok/',
};

Basic.validationSchema = Yup.object().shape({
  name: Yup.string().required('O campo Nome é obrigatório.'),
  email: Yup.string()
    .email('Digite um e-mail válido.')
    .required('O campo E-mail é obrigatório.'),
  phone: Yup.string(),
  uf: Yup.string().required('O campo Estado é obrigatório.'),
  city: Yup.string().required('O campo Cidade é obrigatório.'),
  material: Yup.bool(),
  subscribe: Yup.bool(),
});

Basic.captcha = true;
Basic.element = Basic;
export default Basic;
